import React, { useEffect, useState } from "react";
import "./Map.css";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { useRecoilState } from 'recoil'
import { atomobj } from '../C'
import { useNavigate } from "react-router-dom";
import Loader from "../Skleton/Loader";
import { url } from "../utils/baseurl";
function Map() {
  const [isScriptLoaded, setIsScriptLoaded] = useState(true);
  const [isScriptLoadSucceed, setIsScriptLoadSucceed] = useState(false);
  const [locs, setlocs] = useState([]);
  const [alertinfo, setalertinfo] = useState([]);
  const [agencyCount, setAgencyCount] = useState(0);
  const [rescuedCount, setRescuedCount] = useState(0);
  const [msgofatm, setmsgofatm] = useRecoilState(atomobj)
  const [earthquakeinfo, setearthquakeinfo] = useState([])

  const [onlyredalerts, setonlyredalerts] = useState([])



  const [isloading, setisloading] = useState(true)




  const nav = useNavigate()

  const handleScriptLoad = () => {
    setIsScriptLoaded(true);
  };

  const handleScriptError = () => {
    setIsScriptLoaded(false);
  };

  async function getAllAlerts() {
    setisloading(true);
    try {
      const response = await fetch(
        `${url}/FetchAllAlertDetails`
      );
      const data = await response.json();
  
      const centroids = data.map((item) => item.centroid);
      setlocs(centroids);
      setalertinfo(data);
  
      const abc = data.filter((e) => e.severity_color === "red");
      console.log(abc);
  
      setonlyredalerts(abc);
  
      setisloading(false);
  
      // Check if response has come
      console.log("Yes responded");
    } catch (error) {
      console.error("Error fetching data:", error);
      setisloading(false);

    }
  }
  







  useEffect(() => {
    if (isScriptLoaded) {
      setIsScriptLoadSucceed(true);
      getAllAlerts();
    }
  }, [isScriptLoaded]);

  const mapContainerStyle = {
    width: "100%",
    height: "600px",
  };

  const center = {
    lat: 20.5937, // Latitude of India
    lng: 78.9629,
  };

  useEffect(() => {
    const targetAgencyCount = 123;
    const targetRescuedCount = 993;
    const duration = 2000; // Duration in milliseconds
    const interval = 16; // Update every 16ms (approximately 60 FPS)
    const agencyIncrement = Math.ceil(
      targetAgencyCount / (duration / interval)
    );
    const rescuedIncrement = Math.ceil(
      targetRescuedCount / (duration / interval)
    );

    let agencyIntervalId, rescuedIntervalId;

    const startCounting = () => {
      agencyIntervalId = setInterval(() => {
        setAgencyCount((prevCount) =>
          prevCount + agencyIncrement < targetAgencyCount
            ? prevCount + agencyIncrement
            : targetAgencyCount
        );
      }, interval);

      rescuedIntervalId = setInterval(() => {
        setRescuedCount((prevCount) =>
          prevCount + rescuedIncrement < targetRescuedCount
            ? prevCount + rescuedIncrement
            : targetRescuedCount
        );
      }, interval);
    };

    startCounting();

    return () => {
      clearInterval(agencyIntervalId);
      clearInterval(rescuedIntervalId);
    };
  }, []);

  return (
    <>
{isloading?<>


<Loader></Loader>
<Loader></Loader>








</>:<>



<div className="map-outer-box">
        {/* <h1>ALERT REGIONS</h1> */}
        <div className="map-inner-box">
          <LoadScript
            googleMapsApiKey="AIzaSyAPEgecVTqBmxZC1D6SIhcp01caAwqZj3I"
            onLoad={handleScriptLoad}
            onError={handleScriptError}
          >
            {isScriptLoadSucceed && (
              <>
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={center}
                  zoom={4}
                >
                  {locs.map((centroid, index) => {
                    const [lng, lat] = centroid.split(",").map(Number);
                    return (
                      <Marker
                        key={index}
                        position={{ lat, lng }}
                       
                      />
                    );
                  })}
                </GoogleMap>
              </>
            )}
          </LoadScript>
        </div>

{onlyredalerts.length>0?<>




  <div className="redalertinfo-box">

 



        <h2 className="text-red-600 font-bold text-2xl mb-4">RED ALERT REGION</h2>

          {alertinfo.map((item, index) =>
            item.severity_color === "red" ? (
              <>

                <div key={index} className="redalertinfo-item"     onClick={()=>{
              
              
              
              setmsgofatm(item)

              nav('/specific')
            
            }}>




                  <p className="redalertinfo-text">
                    <span> {item.area_description} </span>
                  </p>
                </div>
                <br />
              </>
            ) : (
              <></>
            )
          )}
        </div>



</>:<>
<div className="redalertinfo-box">
        <h2 className="text-red-600 font-bold text-2xl mb-4">NO RED ALERT REGION</h2>

     
        </div>





</>}


    
      </div>

      <br />
      <br />

     <div className="total">
        <div className="totalagency">
          <span className="redspan">{agencyCount}</span>

          <span className="bluespan"> AGENCY's</span>
        </div>

        <div className="totalrescued">
          <span className="redspan2">{rescuedCount}</span>

          <span className="bluespan">SURVIORS</span>
        </div>
      </div>

      <br />
      <div className="flex justify-center items-center " onClick={()=>{nav('/earthq')}}>
  <div className="w-80% bg-white p-8 shadow-lg rounded-lg animate-pulse my-4">
    <p className="text-blue-500 text-xl font-bold text-center">
      View Earthquake Map
    </p>
  </div>
</div>


      <br />



{alertinfo.length>0?<>


  <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >


  <h2 className="text-black-600 font-bold text-2xl mb-4">ALL ALERTS</h2>
      </div>


      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
      <i>(Tap on the particular region to get detailed info)</i>
      </div>
      <br />
      <br />







      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
  {alertinfo.map((item, index) => (
    <div
      key={index}
      className={`bg-${item.severity_color}-200 shadow-md hover:shadow-lg rounded-lg p-4 transition-all duration-300 cursor-pointer`}
      onClick={() => {
        setmsgofatm(item);
        nav("/specific");
      }}
      style={{ borderRight: `6px solid ${item.severity_color}` }}
    >
      <p className="alertinfo-text">
        <span className="custom-span">{item.area_description}</span>
      </p>
    </div>
  ))}
</div>







      <br />
      <br />
      <br />




</>:<>


<div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >


  <h2 className="text-black-600 font-bold text-2xl mb-4">No live alerts found</h2>
      </div>


      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
      <i>(Visit again later)</i>
      </div>
      <br />
      <br />







</>}







</>}


    </>
  );
}

export default Map;
